import { useState } from 'react';
import Box from '@mui/material/Box';

import Typography from '@mui/material/Typography';

import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2
import { OpenSwal } from '../../Utils';

import { useNavigate } from 'react-router-dom';
import { TextField } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import FormHelperText from '@mui/material/FormHelperText';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';




import FormControl from '@mui/material/FormControl';



import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
// import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { url_cancel_assignment } from '../../RoutesMap';
import { apiWithAuth } from '../../Services/Axios/axios';

// let default_current_time = dayjs.tz(new Date(), iti_user_timezone);

export default function AssignmentCancelComp({ assign_id, AssignmentCancelReasonsAry, changeAssignStatus, AssignmentCancelReasonSelectShowSet }) {

    const navigate = useNavigate();
    const appThemeColor = "#" + process.env.REACT_APP_THEME_COLOR;
    const appThemeSecondaryColor = process.env.REACT_APP_THEME_SECONDARY_COLOR;
    const [CancelReasonSelectValue, CancelReasonSelectValueSet] = useState('');
    const [CancelReasonSelectErrormsg, CancelReasonSelectErrormsgSet] = useState(false);
    // const [manualCompletionRemarksShowHide, manualCompletionRemarksShowHideSet] = useState(false);
    const [CancelRemarksErrormsg, CancelRemarksErrormsgSet] = useState(false);
    // const [signatureEmptyError, signatureEmptyErrorSet] = useState(false);
    const [FinalCancelButtonLoading, FinalCancelButtonLoadingSet] = useState(false);


    const manualReasonSelect = (element) => {
        let value = element.target.value;
        CancelReasonSelectValueSet(value);


    }
    const cancelAssignmentFinal = () => {
        let validation_check = true;
        if (CancelReasonSelectValue === "") {
            validation_check = false;
            CancelReasonSelectErrormsgSet(true);
        } else {
            CancelReasonSelectErrormsgSet(false);

        }
        let cancel_reason_select_text_value = document.getElementById('cancel_reason_select').innerText;
        // console.log(cancel_reason_select_text_value)
        let cancel_remarks = document.getElementById('cancel_remarks').value;
        if (cancel_remarks === "") {
            validation_check = false;
            CancelRemarksErrormsgSet(true);
        } else {
            CancelRemarksErrormsgSet(false);

        }

        if (validation_check) {
            FinalCancelButtonLoadingSet(true);
            let payload_data = { assignid: assign_id, cancel_remark: cancel_remarks, cancel_reason: CancelReasonSelectValue }
            apiWithAuth.post(url_cancel_assignment, payload_data, { headers: { "Content-Type": "multipart/form-data" } }).then(response => {
                if (response.data.status) {
                    AssignmentCancelReasonSelectShowSet(cancel_reason_select_text_value);
                    changeAssignStatus('CancelEnd');
                } else if (response.data.status === false && response.data.message === "Token Expired") OpenSwal('Token_error', navigate);
                else OpenSwal('Axios_error', response.data.message);


            }).catch(response => OpenSwal('Axios_error', response.message));
        }


    }


    return (

        <Box>
            <Box sx={{ mt: 2, mb: 10, ml: 2 }}>



                <Grid container spacing={4} sx={{ mt: 1 }} >
                    <Grid xs={12} sm={6} md={6}>
                        <Box>
                            <Typography variant="body1" color={appThemeColor} >Please share why you are withdrawing from the assignment</Typography>
                            <FormControl sx={{ width: { xs: '100%', sm: '60%' }, backgroundColor: '#e0e0e0', mt: 1 }}   >
                                <InputLabel id="cancel_reason_select_label" ><Typography color={(CancelReasonSelectErrormsg) ? '#d32f2f' : appThemeColor}>Choose Reason*</Typography></InputLabel>
                                <Select
                                    id="cancel_reason_select" value={CancelReasonSelectValue}
                                    onChange={(evt) => manualReasonSelect(evt)} color={appThemeSecondaryColor}
                                    label="Choose Reason*"
                                    error={(CancelReasonSelectErrormsg) ? true : false}  >
                                    {AssignmentCancelReasonsAry.map((data, key) => {
                                        return <MenuItem key={key} value={data.cancel_id}>{data.cancel_reason}</MenuItem>
                                    })}

                                </Select>
                            </FormControl>
                            {CancelReasonSelectErrormsg && <FormHelperText error={true}>Please choose reason</FormHelperText>}

                        </Box>
                    </Grid>
                    <Grid xs={12} sm={6} md={6}>
                        <Box  >  <Typography variant="body1" color={appThemeColor} >Withdrawal Remarks</Typography>
                            <TextField fullWidth label='Withdrawal Remarks'
                                id="cancel_remarks" multiline rows={3} required error={(CancelRemarksErrormsg) ? true : false}
                                color={appThemeSecondaryColor} sx={{ backgroundColor: '#e0e0e0', mt: 1, width: { xs: '100%', sm: '60%' } }} />
                            {CancelRemarksErrormsg && <FormHelperText error={true}>Remarks Required</FormHelperText>}
                        </Box>

                    </Grid>

                </Grid>
                <Box sx={{ mt: 4, display: 'flex', justifyContent: 'center' }}>
                    <LoadingButton variant="contained" sx={{ backgroundColor: '#89B601', color: '#fff', fontWeight: 'bold', '&:hover': { backgroundColor: '#5f7f00' }, width: '250px' }} loadingPosition="center" onClick={cancelAssignmentFinal} endIcon={<CheckCircleOutlineOutlinedIcon />} loading={FinalCancelButtonLoading} >Submit</LoadingButton>

                </Box>









            </Box>

        </Box >

    )
}

